export default __webpack_public_path__ + "static/media/Tasset of Vehement Thunder.fcbe8567.jpg";